import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import './sass/main.sass'
import './sass/variables.scss'

import Vuelidate from 'vuelidate'
import VuetifyDialog from 'vuetify-dialog'
import VConfirm from './components/VDialog/VConfirm'
import 'vuetify-dialog/dist/vuetify-dialog.css' // remove this

Vue.config.productionTip = false

// vuetify dialog
Vue.use(VuetifyDialog, {
  context: {
    vuetify
  }
})
Vue.prototype.$dialog.component('warning', VConfirm, {
  waitForResult: true,
  actions: {
    false: 'Cancelar',
    true: {
      text: 'Continuar',
      color: 'primary'
    }
  }
})
Vue.prototype.$dialog.message = {
  info: (message, options) => Vue.prototype.$dialog.toast({
    text: message,
    color: 'blue-grey darken-1',
    position: 'top-center',
    ...options
  }),
  error: (message, options) => Vue.prototype.$dialog.toast({
    text: message,
    color: 'red darken-1',
    position: 'top-center',
    ...options
  }),
  success: (message, options) => Vue.prototype.$dialog.toast({
    text: message,
    color: 'green darken-1',
    position: 'top-center',
    ...options
  }),
  warning: (message, options) => Vue.prototype.$dialog.toast({
    text: message,
    color: 'amber darken-1',
    position: 'top-center',
    ...options
  })
}
// end vuetify dialog

Vue.use(Vuelidate)

Vue.prototype.$JS_BASE = process.env.VUE_APP_JS_BASE
Vue.prototype.$PAY_BASE = process.env.VUE_APP_PAY_BASE

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
